<template>
  <div class="container">
    <v-suburb v-show="ifSuburb" @change="changeSuburb" @close="suburbClose()"></v-suburb>
    <div class="main" v-show="!ifSuburb">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">专业消毒</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>专业消毒</h2>
            <div class="notice-box" v-show="ifHoliday()">
                <div class="notice-yellow">
                    {{holidayWord()}}
                </div>
            </div>
            <div>
                <div class="weui-cells__title" >联系信息</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请填写联系人称呼" v-model="data.username"> 
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请填写联系人手机号" v-model="data.userphone">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title" >消毒详情</div>
                <div class="weui-cells weui-cells_checkbox">
                    <label class="weui-cell weui-check__label" for="s11" >
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s11" value="1" v-model="data.service" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>住宅消毒</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s12">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s12" value="2" v-model="data.service" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>商业消毒</p>
                        </div>
                    </label>
                </div>
                <div class="weui-cells " v-if="data.service" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after" v-if="data.service=='1'">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">住宅户型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.house_layout">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1">Master Room</option>
                                <option value="2">一室一卫</option>
                                <option value="3">两室一卫</option>
                                <option value="4">两室两卫</option>
                                <option value="5">三室一卫</option>
                                <option value="6">三室两卫</option>
                                <option value="7">其他户型</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after" v-if="data.service=='2'">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">行业类型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.business_layout">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1">办公室</option>
                                <option value="2">餐厅</option>
                                <option value="3">仓库</option>
                                <option value="4">学校</option>
                                <option value="5">酒店</option>
                                <option value="6">娱乐场所</option>
                                <option value="7">其他行业</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label for="" class="weui-label">预约日期</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="date" value="" placeholder="预约消毒的日期" v-model="data.service_date" :min="dateToday()">
                        </div>
                    </div>

                </div>
                    <div class="weui-cells__title" v-if="data.service">地址详情</div>
                    <div class="weui-cells weui-cells_form"  v-if="data.service">
                        <div class="weui-cell">
                            <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" placeholder="如：Unit 2, 9 Hunter St"  v-model="data.address_street">
                            </div>
                        </div>
                        <div class="weui-cell weui-cell_access padding-fix"  @click="suburbSelect()">
                            <div class="weui-cell__hd">
                                <label class="weui-label">Suburb</label>
                            </div>
                            <div class="weui-cell__bd" v-if="data.address_suburb==''"> 
                                <p class="placeholder-color">如：Chatswood</p>
                            </div>
                            <div class="weui-cell__bd" v-if="data.address_suburb!=''"> 
                                <p>{{data.address_suburb}}</p>
                            </div>
                            <div class="weui-cell__ft"></div>
                        </div>
                        <div class="weui-cell weui-cell_select weui-cell_select-after">
                            <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                            <div class="weui-cell__bd">
                                <select class="weui-select" name="select2" >
                                    <option value="NSW" selected>NSW</option>
                                </select>
                            </div>
                        </div>
                        <div class="weui-cell" >
                            <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" v-model="data.address_postcode" placeholder="如：2000">
                            </div>
                        </div>
                    </div>
                    <div class="weui-cells__title" v-if="data.service">消毒频率</div>
                    <div class="weui-cells weui-cells_checkbox" v-if="data.service">
                        <label class="weui-cell weui-check__label" for="s21" >
                            <div class="weui-cell__hd">
                                <input type="radio" class="weui-check" name="checkbox2" id="s21" value="1" v-model="data.service_frequency" >
                                <i class="weui-icon-checked"></i>
                            </div>
                            <div class="weui-cell__bd">
                                <p>一次性消毒</p>
                            </div>
                        </label>
                        <label class="weui-cell weui-check__label" for="s22">
                            <div class="weui-cell__hd">
                                <input type="radio" name="checkbox2" class="weui-check" id="s22" value="2" v-model="data.service_frequency" >
                                <i class="weui-icon-checked"></i>
                            </div>
                            <div class="weui-cell__bd">
                                <p>定期消毒</p>
                            </div>
                        </label>
                    </div>
                    <div class="weui-cells__title" v-if="data.service">需求备注</div>
                    <div class="weui-cells weui-cells_form" v-if="data.service">
                        <div class="weui-cell">
                            <div class="weui-cell__bd">
                                <textarea class="weui-textarea" placeholder="请填写更多需求备注" rows="3" v-model="data.message"></textarea>
                            </div>
                        </div>
                    </div>
                <br>
            </div>
        </div>
        <div class="btn-box-fix">
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">提交表单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div v-show="postSuccess">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">提交成功</strong></div>
            <div class="weui-dialog__bd">感谢您的提交，希望我们可以顺利达成合作！我们将尽快与您联系</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="goto('/')">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交</p>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
        data:{
            token:0,
            type_id:1550735976,
            service:"",
            username:"",
            userphone:"",
            service_date:"",
            service_frequency:"",
            house_layout:"",
            business_layout:"",
            address_state:"NSW",
            address_suburb:"",
            address_street:"",
            address_postcode:"",
            message:"",
        },
        isSending:false,
        localError:[],
        localErrorShow:false,
        postSuccess:false,
        ifSuburb:false,
        rememberTop:""
    }
  },
  methods: {
    suburbSelect: function() {
        this.rememberTop = window.scrollY;
        this.ifSuburb=true;
        document.querySelector("html").classList.remove("service-disinfect-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    changeSuburb: function(suburb,postcode) {
        this.data.address_suburb = suburb;
        this.data.address_postcode = postcode;
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-disinfect-bg");
        this.ifSuburb=false;

    },
    suburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-disinfect-bg");
        this.ifSuburb=false;
    },
    goBack: function() {
        this.$router.push('/service/disinfect');
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    submitOrder: function() {
        if(!this.checkSubmit()){
            return false;
        }
        else{
            this.submitOrderPost();
        }

    },
    dateToday: function(){
        let today = new Date().toISOString().slice(0, 10);
        return today;
    },
    checkSubmit(){
        this.localError = [];

        if (!this.data.username) {
            this.localError.push("请填写联系人名称");
        }
        if (!this.data.userphone) {
            this.localError.push("请填写联系电话");
        }
        if (!this.data.service) {
            this.localError.push("请选择消毒类型：住宅/商业");
        }
        if(this.data.service=='1'){
            if (!this.data.house_layout) {
                this.localError.push("请选择住宅户型");
            }
        }
        if(this.data.service=='2'){
            if (!this.data.business_layout) {
                this.localError.push("请选择行业类型");
            }
        }
        if (!this.data.service_date) {
            this.localError.push("请选择服务日期");
        }
        if (!this.data.address_street) {
            this.localError.push("请填写服务地址 Street 信息");
        }
        if (!this.data.address_suburb) {
            this.localError.push("请填写服务地址 Suburb 信息");
        }
        if (!this.data.address_postcode) {
            this.localError.push("请填写服务地址 Postcode 信息");
        }
        if (!this.data.service_frequency) {
            this.localError.push("请填写服务频率");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
        }
        else{
            orderObject.token = 0;
        }
        
        this.axios.post(this.apiURL()+'/Order/createTempOrder', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.$router.push('/order-form-success?id='+response.data.data.order_id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-disinfect-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-disinfect-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.container /deep/ .weui-cell__ft .qty span{
    font-size:1em;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}


</style>



// WEBPACK FOOTER //
// src/pages/service/form/disinfect.vue